<template>
  <v-app>
    <template>
      <v-app-bar
        app
        src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
        dark
      >
        <router-link to="/home">
          <v-toolbar-title style="color: white;">
            Master Setting
          </v-toolbar-title> 
        </router-link>

        <div
          v-for="linkGroup in filteredGroups"
          :key="linkGroup.title"
          class="text-center ml-10"
        >
          <v-menu
            open-on-hover
            bottom
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="white"
                text
                dark
                v-on="on"
              >
                {{ linkGroup.title }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(link, i) in linkGroup.links"
                :key="i"
                :to="link.to"
              >
                <v-list-item-title
                  class="caption"
                >
                  {{ link.title }}
                </v-list-item-title>
              </v-list-item> 
            </v-list>
          </v-menu>
        </div> 
        <v-spacer />
            
        <v-btn
          icon
          title="Logout"
          @click="logout"
        >
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </v-app-bar>
    </template>
    <router-view />
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :bottom="bottom"
      :top="top"
      :left="left"
      :right="right"
      dark
    >
      <v-icon
        color="white"
        class="mr-4"
      >
        mdi-bell-plus
      </v-icon>
      <div> {{ message }}</div>
      <v-icon
        size="16"
        @click="setSnackbar(false)"
      >
        mdi-close-circle
      </v-icon>
    </v-snackbar>
    <app-dialog-idle />
  </v-app>
</template>

<script>
  import {
    mapMutations,
    mapState,
  } from 'vuex'
  
  import store from '@/store'

  export default {
    inject: ['$validator'],
    beforeRouteEnter (to, from, next) {
      if (!_.isEmpty(store.state.currentUser)) {
        next()
        return
      }

      // fix for - beforeRouteEnter will trigger twice and trigger double requests
      if (store.state.loading) {
        next()
        return      
      }
      store.state.loading = true

      Promise.all([
        store.dispatch('getCurrentUser'),
      ])          
        .then(([user]) => {
          store.state.loading = false
          next()       
        })
        .catch(() => {
          store.state.loading = false
          next()
        })
    },
    metaInfo () {
      return {
        title: 'Master Setting',
      }
    },
    data () {
      return {
        timerId: '',
        filteredGroups: [],
        linkGroups: [
          {
            title: 'Company',
            links: [
              {
                to: '/company',
                title: 'Company',
                permission: 'company view',
              },
              {
                to: '/company-quota',
                title: 'Company Quota',
                permission: 'company quota view',
              },
            ],
          },
          {
            title: 'Fund Bucket',
            links: [
              {
                to: '/fund-bucket',
                title: 'Fund Bucket',
                permission: 'fund bucket view',
              },
              {
                to: '/fund-bucket-item',
                title: 'Fund Bucket Item',
                permission: 'fund bucket item view',
              },
              {
                to: '/fund-bucket-type',
                title: 'Fund Bucket Type',
                permission: 'fund bucket type view',
              },
              {
                to: '/fund-bucket-has-type',
                title: 'Fund Bucket Has Type',
                permission: 'fund bucket has type view',
              },
              {
                to: '/fund-bucket-item-description',
                title: 'Fund Bucket Item Description',
                permission: 'fund bucket item description view',
              },
            ],
          },
          {
            title: 'Payment Channel',
            links: [
              {
                to: '/payment',
                title: 'Payment Channel',
                permission: 'payment channel view',
              },
              {
                to: '/payment-channel-type',
                title: 'Payment Channel Type',
                permission: 'payment channel type view',
              },
              {
                to: '/branch-payment-channel',
                title: 'Branch Payment Channel',
                permission: 'branch payment channel view',
              },
            ],
          },
          {
            title: 'Tax',
            links: [
              {
                to: '/tax',
                title: 'Tax Setting',
                permission: 'tax setting view',
              },
            ],
          },
        ],
      }
    },
    computed: {
      ...mapState('app', ['message', 'snackbarColor', 'top', 'bottom', 'left', 'right', 'dialog', 'dialogTitle', 'dialogMessage', 'dialogColor']),
      snackbar: {
        get () {
          return this.$store.state.app.snackbar
        },
        set (val) {
          this.setSnackbar(val)
        },
      },
    },
    beforeDestroy () {
      clearTimeout(this.timerId)
    },
    created () {   
      this.populateMenus()      
    },
    mounted () {
      this.interceptHttpResponses()
      this.setExpirationInterval()      
    },
    methods: {
      ...mapMutations('app', ['setSnackbar', 'setDialog']),
      populateMenus () {
        this.linkGroups.map(linkGroup => {
          const links = linkGroup.links.filter(link => {
            if (link.permission) {
              if (this.$hasPermissionTo([link.permission])) return link
            } else {
              return link
            }       
          })
          if (links.length < 1) return
          this.$set(linkGroup, 'links', links)
          this.filteredGroups.push(linkGroup)
        })
      },
      interceptHttpResponses () {
        this.$http.interceptors.response.use(undefined, (err) => {
          if ((err.response || {}).status === 401) {
            this.manualLogout()
          } else if (err.response.status === 422) {
            if (err.response.data.errors) {        
              for (const key in err.response.data.errors) {
                this.$validator.errors.add({
                  field: key, 
                  msg: JSON.stringify(err.response.data.errors[key][0]).replace(/"/g, ''),
                })
              }

              this.$scrollToFirstErrorInput()
            }
          } 
          
          if (err.response.status === 403) {
            this.$snack({
              color: 'error',
              message: 'Unauthorized action',
            })
          } 
          
          if (err.response.status === 400) {
            this.$snack({
              color: 'error',
              message: err.response.data.message,
            })
          }

          return Promise.reject(err)
        })
      },
      setExpirationInterval () {      
        let promptInSecs = (this.$store.state.tokenExpiration.getTime() - new Date().getTime()) / 1000

        if (promptInSecs < 0) {
          this.manualLogout()
          return
        }

        if (promptInSecs >= 40) {
          promptInSecs -= 20
        } else {
          promptInSecs = 0
        }

        this.setAccessRefreshTimer(promptInSecs)
      },
      setAccessRefreshTimer (secs) {
        this.timerId = setTimeout(() => {      
          this.refreshAccess()
        }, secs * 1000)
      },
      refreshAccess () {
        this.$refreshAccess()
          .then(() => {
            this.setExpirationInterval()
          })
      },  
      manualLogout () {
        this.$manualLogout()
          .then(() => {
            this.$router.push({ path: '/login' })
          })
      },
      logout () {
        this.$logout()
          .then((response) => {
            this.$router.push({ path: '/login' })        
          })
      },
    },
  }
</script>

<style lang="scss">
  #core-view {
    padding-bottom: 100px;
  }

  @import '@/styles/index.scss';
</style>
